import { ApplicationConfig, provideBrowserGlobalErrorListeners, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePtBr from '@angular/common/locales/pt';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';

registerLocaleData(localePtBr, 'pt-BR');

const SmartVisionPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#E8EDFF',
      100: '#C5D1FE',
      200: '#9BB0FE',
      300: '#6B8CFE',
      400: '#3D6AFE',
      500: '#063DFE',
      600: '#0534D9',
      700: '#042BB3',
      800: '#03228D',
      900: '#021968',
      950: '#010F42',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    MessageService,
    providePrimeNG({
      theme: {
        preset: SmartVisionPreset,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
  ],
};
